import { render, staticRenderFns } from "./index-view.vue?vue&type=template&id=a2297ff6&"
import script from "./index-view.vue?vue&type=script&lang=js&"
export * from "./index-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports